import {
  Box,
  GreyGrey80,
  GreyGrey90,
  Primary13Regular,
  Primary13SemiBold,
  Text
} from '@sequencehq/core-components'

export const CreditGrantsEmptyState = () => (
  <Box
    width="400px"
    margin="12px auto"
    textAlign="center"
    data-testid="creditGrants.empty"
  >
    <Text {...Primary13SemiBold} color={GreyGrey90}>
      No credit grants to display
    </Text>
    <Text {...Primary13Regular} color={GreyGrey80}>
      You have not created credit grants for this customer yet.
    </Text>
  </Box>
)
